// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"fbeefb25","421":"8e40daac"}[chunkId] + ".chunk.css";
};